module.exports = __webpack_public_path__ + "static/media/OHrdlička-96-2.da9c502f.jpg";